import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

// HB: places a "Size Guide" link beside the Size dropdown inside the
// variant-picker's own <form> (see the 2-column grid scoped to
// .variant-picker__form in product-information.liquid).
//
// This element owns a <template> with the link markup (see
// custom_liquid_sizeguide_pos in templates/product.json) and clones it into
// the form. A clone -- not the original element from templates/product.json
// -- is required because the theme's variant-picker component replaces its
// own <form> contents whenever a variant is selected (to update swatch/
// select states); anything we'd moved INTO that form is destroyed in the
// process. Re-cloning from this permanently-safe template (it lives in the
// Header group, never touched by variant-picker's own re-render) after
// every productSelect event keeps the link from disappearing on variant
// change, instead of a one-time DOM move which only survives the first
// swatch click.
class SizeGuidePosition extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#move();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(() => {
        requestAnimationFrame(() => this.#move());
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[size-guide-position] Event promise rejected:', error);
      });
  };

  #move() {
    const template = this.querySelector('template');
    const sizeFieldset = document.querySelector('[data-option-name="Size"]');
    if (!template || !sizeFieldset || !sizeFieldset.parentElement) return;

    const existing = sizeFieldset.parentElement.querySelector(':scope > [data-hb-size-guide-clone]');
    if (existing) existing.remove();

    const fragment = template.content.cloneNode(true);
    const clone = fragment.firstElementChild;
    if (!clone) return;
    clone.setAttribute('data-hb-size-guide-clone', '');
    sizeFieldset.parentElement.insertBefore(clone, sizeFieldset.nextSibling);
  }
}

if (!customElements.get('size-guide-position')) {
  customElements.define('size-guide-position', SizeGuidePosition);
}
